import Carousel from "@/src/components/common/carousel";
import Image from "next/image";
import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";
import NextLink from "next/link";
import Link from "next/link";

const Announcements = ({ announcements }) => {
    return (
        <div className="bg-gray-100 md:py-8 py-5">
            <div className="max-w-6xl mx-auto">
                <h2 className="md:text-2xl text-xl text-black font-bold md:mb-6 mb-2 md:text-left text-center">
                    Announcements
                </h2>
                <Carousel
                    settings={{
                        infinite: true,
                        speed: 700,
                        slidesToShow: 3,
                        slidesToScroll: 2,
                        // centerMode: true,
                        responsive: [
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                    centerMode: true,
                                    centerPadding: "25px",
                                },
                            },
                        ],
                    }}
                >
                    {announcements?.length > 0 &&
                        announcements?.map((item) => (
                            <div
                                key={item?.announcementId}
                                className="md:py-2 py-1"
                            >
                                <div className="bg-white p-1 shadow-md rounded-lg min-h-80 flex flex-col relative md:mx-3 mx-1 overflow-hidden">
                                    <div className="flex flex-col">
                                        <div className="relative md:h-48 h-40">
                                            <Image
                                                src={
                                                    !!item.cardImage
                                                        ? `${NEXT_IMAGE_CDN}/${item.cardImage}`
                                                        : `${NEXT_IMAGE_CDN}/product-cards/Blood-Group.jpg`
                                                }
                                                alt={
                                                    item?.cardImageAlt ||
                                                    item.announcementTitle
                                                }
                                                width={0}
                                                height={0}
                                                sizes="(max-width: 768px) 100vw, 33vw"
                                                className="object-cover w-full rounded-lg h-full"
                                                loading="lazy"
                                            />
                                        </div>

                                        <div className="md:p-4 p-2">
                                            <h3 className="text-black md:text-lg text-base font-bold truncate">
                                                {item.announcementTitle}
                                            </h3>
                                            <p className="text-gray-600 text-sm truncate">
                                                {item.announcementDesc}
                                            </p>

                                            <div className="md:mt-4 mt-2 flex">
                                                <Link
                                                    href={item?.buttonLink}
                                                    className="bg-primary text-white  px-4 py-2 rounded-xs font-medium text-sm hover:bg-primary/80 transition-all duration-300"
                                                >
                                                    {item.buttonText}
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                </Carousel>
            </div>
        </div>
    );
};

export default Announcements;
